<div class="relative w-full py-2">
  <input
    type="text"
    class="input-base text-metro-blue pl-10 pr-10 w-full"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    [disabled]="disabled"
    [ngClass]="{
      'text-sm py-1.5 px-2.5': size === 'sm',
      'text-base py-2 px-3.5': size === 'md',
      'text-lg py-3 px-4.5': size === 'lg',
      'cursor-not-allowed opacity-60': disabled
    }"
  />

  <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none ">
    <app-metro-icon [svg]="iconSearch" [size]="iconSizeMap[size]" />
  </div>

  @if (clearable && value) {
    <button
      class="absolute inset-y-0 right-0 flex items-center pr-3 "
      (click)="clear()"
      type="button"
    >
      <app-icon [svg]="iconCleareable" [size]="iconSizeMap[size]" />
    </button>
  }
</div>
